import React, { useEffect, FC } from 'react';
import Head from 'next/head';
import generateMetaData from 'lib/utils/generateMetaData';
import { useDispatch } from 'react-redux';
import { setLeadCategoryId } from 'redux/features/globalData-slice';
import { OFF_ROAD_LEAD_CAT_ID } from 'views/rebranded-module/OffRoadToursLandingViewV2/utils/constants';
import { PAGES_GA_IDENTIFIERS } from 'views/common/utils/constants';
import StyledBox from 'views/rebranded-module/OffRoadToursLandingViewV2/OffRoadToursLandingViewV2.styles';
import {
  HeroSection,
  // PopularOffRoadToursSection,
  // PopularOffRoadToursSectionSkeleton,
  OffRoadToursPromoSection,
  OffRoadToursPromoSectionSkeleton,
  OffRoadUTVPromoSection,
  OffRoadUTVPromoSectionSkeleton,
  OffRoadToursHighlightsSection,
  OffRoadToursHighlightsSectionSkeleton,
  ReadyForAdventureSection,
  ReadyForAdventureSectionSkeleton,
  OffRoadAdventuresExperiencesSection,
  OffRoadAdventuresExperiencesSectionSkeleton,
  OurFleetSection,
  OurFleetSectionSkeleton,
  TestimonialsSection,
  TestimonialsSectionSkeleton,
} from 'views/rebranded-module/OffRoadToursLandingViewV2/components';
import { LazyLoad } from 'views/common/components';

const OffRoadToursLandingViewV2: FC<any> = (props) => {
  const { offRoadData } = props;
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setLeadCategoryId(OFF_ROAD_LEAD_CAT_ID));
    window.gtag('event', 'landing_page_view', {
      page_identifier: PAGES_GA_IDENTIFIERS.OFF_ROAD_LANDING,
    });
    return () => {
      dispatch(setLeadCategoryId(null));
    };
  }, []);

  return (
    <StyledBox>
      <Head>
        {offRoadData.seo_values && generateMetaData(offRoadData.seo_values)}
      </Head>
      <HeroSection />
      {/* <LazyLoad skeleton={<PopularOffRoadToursSectionSkeleton />} dataLoaded={offRoadData}>
        <PopularOffRoadToursSection tours={offRoadData.tours} />
      </LazyLoad> */}
      <LazyLoad skeleton={<OffRoadToursPromoSectionSkeleton />} dataLoaded={offRoadData.promo_tour}>
        <OffRoadToursPromoSection promoTour={offRoadData.promo_tour} />
      </LazyLoad>
      <LazyLoad skeleton={<OffRoadToursHighlightsSectionSkeleton />} dataLoaded>
        <OffRoadToursHighlightsSection />
      </LazyLoad>
      <LazyLoad skeleton={<OffRoadUTVPromoSectionSkeleton />} dataLoaded={offRoadData.utv_2_day_promo_tour}>
        <OffRoadUTVPromoSection utv2DayPromoTour={offRoadData.utv_2_day_promo_tour} />
      </LazyLoad>
      <LazyLoad skeleton={<ReadyForAdventureSectionSkeleton />} dataLoaded>
        <ReadyForAdventureSection />
      </LazyLoad>
      <LazyLoad
        skeleton={<OffRoadAdventuresExperiencesSectionSkeleton />}
        dataLoaded>
        <OffRoadAdventuresExperiencesSection />
      </LazyLoad>
      <LazyLoad skeleton={<OurFleetSectionSkeleton />} dataLoaded={offRoadData}>
        <OurFleetSection
          models={offRoadData.vehicle_models}
        />
      </LazyLoad>
      <LazyLoad skeleton={<TestimonialsSectionSkeleton />} dataLoaded>
        <TestimonialsSection />
      </LazyLoad>
    </StyledBox>
  );
};
export { OffRoadToursLandingViewV2 };
